
import React from 'react';
import { LocalString, Plural, Money } from 'translate-react';


let ResponsiveImage = props => {
	return <img {...props} />;
}


let Class = props => {
	let { klass } = props;

	/*
	{klass.id}
	{klass.image}
	{klass.info}
	{klass.inkl}
	{klass.name}
	{klass.quantity}
	{klass.stars}
	*/

	return (
		<div className="class-container">
			<div className="image">
				<ResponsiveImage src={`https:////tramino.s3.amazonaws.com${klass.image}`} />
			</div>
			<div className="class">
				<h3>{klass.name} <span dangerouslySetInnerHTML={{__html: klass.stars}}></span></h3>
				<div className="class-cols">
					<div className="info">{klass.info}</div>
					<div className="facts" dangerouslySetInnerHTML={{__html: klass.facts}}></div>
					<div className="price">
						<span className="value">ab <Money map={{EUR: Math.random() * 200}} /></span>
						<span className="info">
							Gesamtpreis inkl. Endreinigung,
							ohne Verpflegung,
							zzgl. Kurbeitrag
						</span>
					</div>
				</div>
				<br className="clear" />

				<div className="text">{klass.text}</div>
				<div className="tags">
					{klass.tags.map((t, i) => <div className="tag" key={i}>✓&nbsp;&nbsp;{t}</div>)}
				</div>
			</div>
			<br className="clear" />
		</div>
	);
}


let Result = props => {
	let { result } = props;

	/*
	{result.id}
	{result.phone}
	{result.plz}
	{result.ort}
	{result.rating}
	{result.rating_count}
	{result.slogan}
	{result.street}
	*/

	return (
		<div className="result">
			{/*
			<div className="image">
				<ResponsiveImage src={`https:////tramino.s3.amazonaws.com${result.logo}`} />
			</div>

			<h2>{result.name}</h2>
			<p>{result.slogan}</p>
			<p>{result.info}</p>
			<p>
				{result.phone}<br/>
				{result.plz} {result.ort}
			</p>

			*/}

			{result.classes.slice(0, 5).map((c, i) => <Class klass={c} key={i} />)}
			<br className="clear" />
		</div>
	);
}


export default function ResultsList(props) {
	let { results } = props;

	return (
		<div>
			{results.map((r, i) => <Result result={r} key={i} />)}
		</div>
	);
}



/** WEBPACK FOOTER **
 ** ../ibe/desktop/ResultsList.js
 **/